import type { Dict } from '@/i18n';

/**
 * Breadcrumb label per route. Kept beside the router rather than passed down
 * from each page so the topbar has a title even before a page renders.
 */
const titles: Record<string, (t: Dict) => string> = {
  '/': (t) => t.headings.dashboard,
  '/appointments': (t) => t.headings.appointments,
  '/patients': (t) => t.headings.patients,
  '/invoices': (t) => t.headings.billing,
  '/inventory': (t) => t.headings.inventory,
  '/pharmacy': (t) => t.headings.medSale,
  '/lab': (t) => t.headings.lab,
  '/reports/revenue': (t) => t.headings.revenue,
  '/settings': (t) => t.headings.settings,
  '/styleguide': () => 'Styleguide',
};

export function screenTitle(pathname: string, t: Dict): string {
  const exact = titles[pathname];
  if (exact) return exact(t);

  // Detail routes (/patients/42) inherit their section's title.
  const section = Object.keys(titles)
    .filter((path) => path !== '/' && pathname.startsWith(`${path}/`))
    .sort((a, b) => b.length - a.length)[0];

  return section ? (titles[section] as (t: Dict) => string)(t) : t.clinicName;
}
